import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { AmountSkeleton as v } from "../AmountSkeleton/AmountSkeleton.js";
import { BASE_CLASS as y, BODY_CLASS as T, PLACEHOLDER_CLASS as E, LABEL_CLASS as b, AMOUNT_CLASS as B } from "./constants.js";
import { SummaryItemLabel as h } from "./SummaryItemLabel.js";
import { Tooltip as N } from "../../../../internal/Tooltip/Tooltip.js";
import { TypographyVariant as p } from "../../../../internal/Typography/types.js";
import O from "../../../../internal/Typography/Typography.js";
import _ from "../../../../../core/Context/useCoreContext.js";
import n from "classnames";
import { useEffect as x, useCallback as H } from "../../../../../external/preact/hooks/dist/hooks.module.js";
/* empty css                 */
import { useResponsiveViewport as I, mediaQueries as w } from "../../../../../hooks/useResponsiveViewport.js";
const W = ({
  columnConfigs: i,
  isHeader: u = !1,
  isHovered: c = !1,
  isSkeletonVisible: l = !1,
  isLoading: C = !1,
  widths: m,
  onWidthsSet: L,
  isEmpty: A
}) => {
  const { i18n: s } = _();
  x(() => {
    const e = i.map((r) => {
      var a, o;
      return ((o = (a = r.ref) == null ? void 0 : a.current) == null ? void 0 : o.getBoundingClientRect().width) ?? 0;
    });
    L(e);
  }, [L]);
  const d = (e) => ({ width: m && m[e] ? m[e] : "auto" }), S = I(w.only.xs), f = H(
    (e, r) => e.valueHasLabelStyle ? p.CAPTION : r && !S ? p.BODY : p.TITLE,
    [S]
  );
  return /* @__PURE__ */ t("div", { className: n(y, { [T]: !u }), children: i.map((e, r) => {
    const a = e.getValue(), o = !!a && a.length > 12;
    return /* @__PURE__ */ t("div", { children: [
      u && (e.tooltipLabel ? /* @__PURE__ */ t(N, { content: s.get(`${e.tooltipLabel}`), isContainerHovered: c, children: /* @__PURE__ */ t(h, { config: e, i18n: s, isSkeletonVisible: l }) }) : /* @__PURE__ */ t(h, { config: e, i18n: s, isSkeletonVisible: l })),
      l ? /* @__PURE__ */ t(v, { isLoading: C, hasMargin: e.hasSkeletonMargin, width: e.skeletonWidth + "px" }) : A ? /* @__PURE__ */ t("span", { className: n([y, E]) }) : /* @__PURE__ */ t("div", { ref: e.ref, style: d(r), children: /* @__PURE__ */ t(
        O,
        {
          variant: f(e, o),
          className: n({ [b]: e.valueHasLabelStyle, [B]: !e.valueHasLabelStyle }),
          children: a
        }
      ) })
    ] }, r);
  }) });
};
export {
  W as SummaryItem
};
